// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"35726c7e123a0174ec69","888":"5eb25b8008593ce0f351"}[chunkId] + ".css";
};